import { Rpc } from "./rpc";

export class TeamRpc {

    public static list(): Promise<TeamListResponse> {
        return Rpc.GET("/rpc/team/list");
    }

    private constructor() {}

}

export interface TeamListResponse {

    readonly teams: TeamListItem[];

}

export interface TeamListItem {

    readonly id: number;
    readonly name: string;

}